import React, { Fragment } from "react";
import { isMobile } from "react-device-detect";

import CatchStoryThumb from "components/boards/post/catchstory/CatchStoryThumb";
import CatchStoryMoreButton from "components/boards/post/catchstory/CatchStoryMoreButton";

const CatchStoryItem = ({
    location,
    vod = {},
    authority = {},
    inflowPath,
    moreButtonTop,
    storyOrderInTotal,
    total,
    loading = false,
    compareBroadDate
}) => {
    if (loading) {
        return (
            <>
                {!isMobile && (
                    <div className="grid">
                        <div></div>
                    </div>
                )}

                {isMobile && (
                   <div className="grid"></div>
                )}
            </>
        );
    }

    return (
        <Fragment>
            {/* 캐치 세로형 썸네일 노출 */}
                <CatchStoryThumb
                    inflowPath={inflowPath}
                    vod={vod}
                    authority = {authority}
                    storyOrderInTotal={storyOrderInTotal}
                    total={total}
                    compareBroadDate={compareBroadDate}
                    location={location}
                />
            {/* 쓰리닷 버튼 (홈 탭에는 공유하기 버튼 미노출) */}
            {location != "home" && (
                <CatchStoryMoreButton vod={vod} top={moreButtonTop} authority={authority}/>
            )}
        </Fragment>
    );
};

export default CatchStoryItem;
